import { render, staticRenderFns } from "./OffsiteContactsPrisonerInfo.vue?vue&type=template&id=886fdeba&"
import script from "./OffsiteContactsPrisonerInfo.vue?vue&type=script&lang=js&"
export * from "./OffsiteContactsPrisonerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports